var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout",class:{ 'fullscreen': _vm.isScan },attrs:{"id":"app-layout"}},[_c('Loading'),_c('Head'),_c('router-view'),_c('ModalRemoveFromCart'),_c('ModalEditProduct'),_c('SnackbarDelete'),_c('ModalConfirmOrder'),_c('ModalAPIErrors'),_c('ModalCodeError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }